import * as xlsx from "xlsx"

const readFileAsync = (file) => {
    return new Promise((resolve, reject) => {
        let reader = new FileReader()

        reader.onload = () => {
            resolve(reader.result)
        }

        reader.onerror = reject

        reader.readAsBinaryString(file)
    })
}

const _fixCode = (c: number): string => {
    let _c = c?.toString().replace(/-/g, "").padStart(5, "0")
    if (_c?.length == 5) _c = "979" + _c
    return _c
}

export const parseExcel = async (file): Promise<any[]> => {
    console.log(file)

    const result = await readFileAsync(file)
    const workbook = xlsx.read(result, {
        type: "binary",
    })

    // const sheetName = workbook.SheetNames[0]

    // console.log(workbook.SheetNames)

    const relatedCodes = xlsx.utils.sheet_to_json(workbook.Sheets["Related products"], {
        header: 1,
    })

    const relatedMap: any = {}

    relatedCodes?.forEach((codes: any[]) => {
        const c = codes.shift()
        relatedMap[_fixCode(c)] = codes.map((_c) => _fixCode(_c))
    })

    const variants = xlsx.utils.sheet_to_json(workbook.Sheets["Article variants affiliation"], {
        header: 1,
    })
    const variantsMap: any = {}
    variants?.forEach((codes: any[]) => {
        // each variant has full list of all other variants
        codes?.forEach((c) => {
            variantsMap[_fixCode(c)] = codes.map((_c) => _fixCode(_c))
        })
    })

    const importData = xlsx.utils.sheet_to_json(workbook.Sheets["Import"])

    importData?.forEach((row: any) => {
        const c = _fixCode(row["Item number"])
        if (relatedMap[c]) {
            row.xRelated = relatedMap[c]
        }
        if (variantsMap[c]) {
            row.xVariants = variantsMap[c]
        }
    })

    return importData
}
